import React, { useEffect, useRef } from "react"

const TranspondForm = ({
  title,
  formId,
  srcUrl,
  className = "transpond-form",
}) => {
  const formRef = useRef()

  useEffect(() => {
    if (!srcUrl || !formRef.current?.querySelector) {
      return undefined
    }

    if (formRef.current.querySelector("script")) {
      return undefined
    }

    const script = document.createElement("script")
    script.src = srcUrl
    script.async = true
    script.defer = true
    // Script element #ID for debugging/identification. In landing page builder this is generated from the page url and form title.
    script.id = formId
    formRef.current.appendChild(script)

    return undefined
  }, [formId, srcUrl])

  return (
    <div className={className} ref={formRef} suppressHydrationWarning>
      {title && <h2 className="h4">{title}</h2>}
    </div>
  )
}

export default TranspondForm
